module.exports = __webpack_public_path__ + "static/img/logo@2x.094c480.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gallery/logo@2x.png
// module id = 1Iou
// module chunks = 1